(() => {
  const galleries = document.querySelectorAll('[data-fi-gallery]');

  galleries.forEach((gallery) => {
    const main = gallery.querySelector('[data-fi-main-image]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-fi-thumb]'));
    const prev = gallery.querySelector('[data-fi-prev]');
    const next = gallery.querySelector('[data-fi-next]');
    const currentLabels = Array.from(gallery.querySelectorAll('[data-fi-current]'));
    if (!main || !thumbs.length) return;

    let current = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    const show = (index) => {
      current = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[current];
      main.src = thumb.dataset.src;
      main.srcset = thumb.dataset.srcset || '';
      main.alt = thumb.dataset.alt || '';
      currentLabels.forEach((label) => {
        label.textContent = String(current + 1).padStart(2, '0');
      });
      thumbs.forEach((item, i) => {
        item.classList.toggle('is-active', i === current);
        item.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    prev?.addEventListener('click', () => show(current - 1));
    next?.addEventListener('click', () => show(current + 1));
  });

  document.querySelectorAll('.fi-buy-form').forEach((form) => {
    const addButton = form.querySelector('[data-fi-add]');
    const variantInputs = Array.from(form.querySelectorAll('[data-fi-variant-input]'));
    const object = form.closest('[data-fi-object]');
    const price = object?.querySelector('[data-fi-price]');

    variantInputs.forEach((input) => input.addEventListener('change', () => {
      if (price && input.dataset.price) price.textContent = input.dataset.price;
      if (addButton) {
        const available = input.dataset.available === 'true' && addButton.dataset.fiForceDisabled !== 'sold_out';
        addButton.disabled = !available;
        addButton.textContent = available ? 'add to bag' : 'sold out';
      }
    }));

    form.addEventListener('submit', async (event) => {
      if (!addButton || addButton.disabled) return;
      event.preventDefault();

      const original = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'adding...';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        if (!response.ok) throw new Error('Could not add item');

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
        });

        addButton.textContent = 'added';
        window.setTimeout(() => {
          addButton.disabled = false;
          addButton.textContent = original;
        }, 1100);
      } catch (error) {
        addButton.disabled = false;
        addButton.textContent = original;
        HTMLFormElement.prototype.submit.call(form);
      }
    });
  });
})();
